import React, { Component } from "react";
import "./Tutorials.css";
import { MdOutlineDraw, MdPhotoSizeSelectLarge } from "react-icons/md";
import { RiImageEditFill } from "react-icons/ri";
import { BsChatText, BsImage, BsLayersHalf } from "react-icons/bs";
class ImgTutorial extends Component {
  handleClose = () => {
    localStorage.setItem("imgTutorial", "true");
    this.props.close();
  };

  render() {
    return (
      <div className="tutorial-modal">
        <div className="tutorial-modal-content">
          <span className="close" onClick={this.handleClose}>
            &times;
          </span>
          <h2 style={{ textAlign: "center" }}>Image-to-Image Generation</h2>

          <p>Utilize an image as a reference point to create new images.</p>
          <ol>
            <li>
              Select the Image-to-Image icon{" "}
              <BsImage className="tutorial-react-icons" size={20} /> to begin.
            </li>
            <li>
              To upload an image, click on the small square in the top right
              corner, or choose an image from your gallery to serve as the
              reference.
            </li>
            <li>
              Provide a text description outlining your expectations for the new
              image.
            </li>
          </ol>

          <p>
            The generated image will incorporate features from the reference
            image, such as the arrangement of elements and color palette.
          </p>

          <p>
            Generating a new image with the same reference and prompt will yield
            different results. Feel free to experiment and select the image that
            best represents your vision.
          </p>

          <video width="100%" autoPlay="autoplay" muted loop={true}>
            <source src="./videos/image-to-image.mp4" type="video/mp4" />
          </video>

          <button className="tutorial-close-button" onClick={this.handleClose}>
            Close
          </button>
        </div>
      </div>
    );
  }
}

class SketchTutorial extends Component {
  handleClose = () => {
    localStorage.setItem("sketchTutorial", "true");
    this.props.close();
  };

  render() {
    return (
      <div className="tutorial-modal">
        <div className="tutorial-modal-content">
          <span className="close" onClick={this.handleClose}>
            &times;
          </span>
          <h2 style={{ textAlign: "center" }}>Smart Sketch</h2>

          <p>Use a drawing as input</p>
          <ol>
            <li>
              Select the Smart Sketch icon{" "}
              <MdOutlineDraw size={20} className="tutorial-react-icons" /> to
              begin.
            </li>
            <li>
              Use the drawing tool to create an aproximate version of the image.
            </li>
            <li>
              Provide a text description to guide the AI on the details that the
              image should have.
            </li>
          </ol>

          <p>
            The generated image will incorporate features from the sketch, such
            as the arrangement of elements and color palette.
          </p>

          <p>
            Generating a new image with the same reference and prompt will yield
            different results. Feel free to experiment and select the image that
            best represents your vision.
          </p>

          <video width="100%" autoPlay="autoplay" muted loop={true}>
            <source src="./videos/sketch-to-image.mp4" type="video/mp4" />
          </video>

          <button className="tutorial-close-button" onClick={this.handleClose}>
            Close
          </button>
        </div>
      </div>
    );
  }
}

class TextTutorial extends Component {
  handleClose = () => {
    localStorage.setItem("textTutorial", "true");
    this.props.close();
  };

  render() {
    return (
      <div className="tutorial-modal">
        <div className="tutorial-modal-content">
          <span className="close" onClick={this.handleClose}>
            &times;
          </span>
          <h2 style={{ textAlign: "center" }}>Text-to-Image Transformation</h2>

          <ol>
            <li>
              Select the text-to-Image icon{" "}
              <BsChatText size={20} className="tutorial-react-icons" /> to
              begin.
            </li>
            <li>
              Describe with details your idea. A rich description usually leads
              to better images.
            </li>
          </ol>

          <p>
            Generating a new image with the same reference and prompt will yield
            different results. Feel free to experiment and select the image that
            best represents your vision.
          </p>

          <video width="100%" autoPlay="autoplay" muted loop={true}>
            <source src="./videos/text-to-image.mp4" type="video/mp4" />
          </video>

          <button className="tutorial-close-button" onClick={this.handleClose}>
            Close
          </button>
        </div>
      </div>
    );
  }
}

class FAQ extends Component {
  state = {
    textTutorial: false,
    sketchTutorial: false,
    imgTutorial: false,
  };

  handleClose = () => {
    document.body.classList.remove("modal-open");
    this.props.close();
  };

  handleOpenTutorial = (tutorialName) => {
    this.setState({ [tutorialName]: true });
  };

  componentDidMount() {
    document.body.classList.add("modal-open");
  }

  render() {
    return (
      <div className="tutorial-modal">
        {this.state.textTutorial && (
          <TextTutorial
            close={() => {
              this.setState({ textTutorial: false });
            }}
          />
        )}
        {this.state.imgTutorial && (
          <ImgTutorial
            close={() => {
              this.setState({ imgTutorial: false });
            }}
          />
        )}
        {this.state.sketchTutorial && (
          <SketchTutorial
            close={() => {
              this.setState({ sketchTutorial: false });
            }}
          />
        )}
        <div
          className="tutorial-modal-content"
          style={{ verticalAlign: "middle" }}
        >
          <span className="close" onClick={this.handleClose}>
            &times;
          </span>
          <img
            src={"./logo_512.png"}
            alt="Artblast AI logo"
            width="30px"
            style={{ verticalAlign: "middle" }}
          />
          <h1>{" Frequently Asked Questions"}</h1>

          <ul>
            <li>
              <h4>What is Artblast?</h4>
              ArtblastAI is an AI-powered art platform developed by SciFork. It
              offers a range of powerful tools and features that enable users to
              create stunning images with ease. The platform leverages advanced
              AI algorithms and models to provide functionalities such as
              Text-to-Image, Image-to-Image, Inpainting, Image Scaling, and
              Smart Sketch. These capabilities allow users to generate images
              from text descriptions, transform existing images into new
              variations, edit images using inpainting techniques, scale images
              to higher resolutions, and even convert hand-drawn sketches into
              digital artwork. ArtblastAI aims to make art creation more
              accessible, intuitive, and innovative by harnessing the potential
              of artificial intelligence.
            </li>
            <li>
              <h4>
                What is Text-to-image?{" "}
                <BsChatText className="tutorial-react-icons" size={20} />
              </h4>
              ArtblastAI's text-to-image feature enables users to generate
              stunning visual representations directly from textual
              descriptions. By simply describing a scene, character, or concept,
              users can bring their ideas to life with ease. This powerful tool
              harnesses the capabilities of AI to analyze the text input and
              generate corresponding images, eliminating the need for extensive
              manual drawing or design skills. Whether for storytelling, concept
              development, or digital art, the text-to-image feature empowers
              users to unleash their creativity and transform textual
              descriptions into captivating visual content.
              <div
                className="demo-link"
                onClick={() => this.handleOpenTutorial("textTutorial")}
              >
                See demo
              </div>
            </li>

            <li>
              <h4>
                What is Image-to-Image{" "}
                <BsImage className="tutorial-react-icons" size={20} />
              </h4>
              The image-to-image feature in ArtblastAI empowers users to
              transform existing images into new variations with different
              styles or designs. Whether you want to experiment with different
              artistic effects, create unique variations of your artwork, or
              explore new design possibilities, the image-to-image feature
              provides a seamless and intuitive way to generate visually
              striking transformations with just a few clicks.
              <div
                className="demo-link"
                onClick={() => this.handleOpenTutorial("imgTutorial")}
              >
                See demo
              </div>
            </li>
            <li>
              <h4>
                Smart Sketch{" "}
                <MdOutlineDraw className="tutorial-react-icons" size={20} />
              </h4>
              The Smart Sketch feature in ArtblastAI allows users to create
              finished and detailed digital images by combining their hand-drawn
              sketches with text prompts within the platform. Users can sketch
              their ideas directly in ArtblastAI while providing a descriptive
              text prompt to further guide the AI algorithms. The algorithms
              analyze the sketch and text input, refining and enhancing the
              details to generate a polished and complete image. This feature is
              a powerful tool for artists, designers, and anyone seeking to
              seamlessly merge their sketches with AI assistance to produce
              stunning digital illustrations. With ArtblastAI's Smart Sketch
              feature, users can easily bring their artistic visions to life.
              <div
                className="demo-link"
                onClick={() => this.handleOpenTutorial("sketchTutorial")}
              >
                See demo
              </div>
            </li>
            <li>
              <h4>
                What is Image Scaling{" "}
                <MdPhotoSizeSelectLarge
                  className="tutorial-react-icons"
                  size={20}
                />
              </h4>
              Image scaling is a valuable feature offered by ArtblastAI that
              enables users to increase the resolution of their images without
              sacrificing quality or experiencing pixelation. With this
              capability, users can upscale their images to a maximum resolution
              of 2048 x 2048 pixels, ensuring that their artwork maintains its
              clarity and sharpness even when enlarged. Whether you need higher
              resolution images for printing, display purposes, or simply to
              enhance the level of detail, ArtblastAI's image scaling feature
              provides a seamless solution to preserve image quality while
              increasing size.
            </li>
            <li>
              <h4>
                What is In-Painting{" "}
                <RiImageEditFill className="tutorial-react-icons" size={20} />
              </h4>
              Inpainting is a powerful image editing tool in ArtblastAI that
              allows users to make specific changes to their images. By marking
              the area they want to modify with green color, users can provide a
              clear indication to the AI. They can also include a prompt to
              describe the desired changes. The AI combines this information
              with the original image and generates a new image, ensuring that
              only the marked area is modified while the rest remains unchanged.
              Inpainting provides an efficient way to make targeted edits to
              images, just like green screens in movies.
            </li>
            <li>
              <h4>
                What is Background Removal{" "}
                <BsLayersHalf className="tutorial-react-icons" size={20} />
              </h4>
              Background Removal in ArtblastAI is a feature that uses AI to
              automatically remove the background from images. It allows users
              to isolate the main subject or object by eliminating the
              surrounding background. This feature is ideal for various
              applications, providing clean and transparent backgrounds for
              product photography, graphic design, and more.
            </li>
            <li>
              <h4>What is a Credit?</h4>
              In ArtblastAI, a credit is a unit used to represent the cost or
              value associated with performing various operations within the
              platform. Each operation, such as generating an image using
              Text-to-Image, Image-to-Image, or Smart Sketch, scaling an image,
              or performing inpainting, requires a specific number of credits.
              Credits serve as a measure of usage or allocation, allowing users
              to access and utilize the different features and functionalities
              available in ArtblastAI. They enable users to create, modify, and
              enhance their artwork effectively within the platform.
            </li>
            <li>
              <h4>How many credits does it cost to generate an image?</h4>
              In ArtblastAI, the following features have associated costs in
              credits:
              <br />
              <table style={{ color: "white", margin: "20px" }}>
                <thead>
                  <tr>
                    <th>Feature</th>
                    <th>Credit Cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Text-to-Image</td>
                    <td>
                      Artblast uses Stable Diffusion (SD) models 
                      Model: SD1.6: 2 credits, SDXL 2 : 3 credits, SD-Core:6 credits
                    </td>
                  </tr>
                  <tr>
                    <td>Image-to-Image</td>
                    <td>6 credits,</td>
                  </tr>
                  <tr>
                    <td>Smart Sketch</td>
                    <td>{"6 credits (New Model)"}</td>
                  </tr>
                  <tr>
                    <td>Scaling (up to 2048x2048)</td>
                    <td>1 credit</td>
                  </tr>
                  <tr>
                    <td>Inpainting</td>
                    <td>3 credits</td>
                  </tr>
                  <tr>
                    <td>Background Removal</td>
                    <td>3 credits</td>
                  </tr>
                  <tr>
                    <td>Unclip</td>
                    <td>8 credits</td>
                  </tr>
                </tbody>
              </table>
              These credit costs ensure that users have a clear understanding of
              the resources required for utilizing specific features in
              ArtblastAI, allowing them to manage their credits effectively
              while creating and editing their artwork.
            </li>
            <li>
              <h4>What AI models does artblast uses?</h4>
              ArtblastAI utilizes a range of AI models, including stable
              diffusion models, to power its innovative features and
              capabilities.
            </li>
          </ul>
          <button className="tutorial-close-button" onClick={this.handleClose}>
            Close
          </button>
        </div>
      </div>
    );
  }
}


class News extends Component {
  state = {
    textTutorial: false,
    sketchTutorial: false,
    imgTutorial: false,
  };

  handleClose = () => {
    document.body.classList.remove("modal-open");
    this.props.close();
  };

  handleOpenTutorial = (tutorialName) => {
    this.setState({ [tutorialName]: true });
  };

  componentDidMount() {
    document.body.classList.add("modal-open");
  }

  render() {
    return (
      <div className="tutorial-modal">
        {this.state.textTutorial && (
          <TextTutorial
            close={() => {
              this.setState({ textTutorial: false });
            }}
          />
        )}
        {this.state.imgTutorial && (
          <ImgTutorial
            close={() => {
              this.setState({ imgTutorial: false });
            }}
          />
        )}
        {this.state.sketchTutorial && (
          <SketchTutorial
            close={() => {
              this.setState({ sketchTutorial: false });
            }}
          />
        )}
        <div
          className="tutorial-modal-content"
          style={{ verticalAlign: "middle" }}
        >
          <span className="close" onClick={this.handleClose}>
            &times;
          </span>
          <img
            src={"./logo_512.png"}
            alt="Artblast AI logo"
            width="30px"
            style={{ verticalAlign: "middle" }}
          />
          <h1>{" Frequently Asked Questions"}</h1>

          <ul>
            <li>
              <h4>What is Artblast?</h4>
              ArtblastAI is an AI-powered art platform developed by SciFork. It
              offers a range of powerful tools and features that enable users to
              create stunning images with ease. The platform leverages advanced
              AI algorithms and models to provide functionalities such as
              Text-to-Image, Image-to-Image, Inpainting, Image Scaling, and
              Smart Sketch. These capabilities allow users to generate images
              from text descriptions, transform existing images into new
              variations, edit images using inpainting techniques, scale images
              to higher resolutions, and even convert hand-drawn sketches into
              digital artwork. ArtblastAI aims to make art creation more
              accessible, intuitive, and innovative by harnessing the potential
              of artificial intelligence.
            </li>
            <li>
              <h4>
                What is Text-to-image?{" "}
                <BsChatText className="tutorial-react-icons" size={20} />
              </h4>
              ArtblastAI's text-to-image feature enables users to generate
              stunning visual representations directly from textual
              descriptions. By simply describing a scene, character, or concept,
              users can bring their ideas to life with ease. This powerful tool
              harnesses the capabilities of AI to analyze the text input and
              generate corresponding images, eliminating the need for extensive
              manual drawing or design skills. Whether for storytelling, concept
              development, or digital art, the text-to-image feature empowers
              users to unleash their creativity and transform textual
              descriptions into captivating visual content.
              <div
                className="demo-link"
                onClick={() => this.handleOpenTutorial("textTutorial")}
              >
                See demo
              </div>
            </li>

            <li>
              <h4>
                What is Image-to-Image{" "}
                <BsImage className="tutorial-react-icons" size={20} />
              </h4>
              The image-to-image feature in ArtblastAI empowers users to
              transform existing images into new variations with different
              styles or designs. Whether you want to experiment with different
              artistic effects, create unique variations of your artwork, or
              explore new design possibilities, the image-to-image feature
              provides a seamless and intuitive way to generate visually
              striking transformations with just a few clicks.
              <div
                className="demo-link"
                onClick={() => this.handleOpenTutorial("imgTutorial")}
              >
                See demo
              </div>
            </li>
            <li>
              <h4>
                Smart Sketch{" "}
                <MdOutlineDraw className="tutorial-react-icons" size={20} />
              </h4>
              The Smart Sketch feature in ArtblastAI allows users to create
              finished and detailed digital images by combining their hand-drawn
              sketches with text prompts within the platform. Users can sketch
              their ideas directly in ArtblastAI while providing a descriptive
              text prompt to further guide the AI algorithms. The algorithms
              analyze the sketch and text input, refining and enhancing the
              details to generate a polished and complete image. This feature is
              a powerful tool for artists, designers, and anyone seeking to
              seamlessly merge their sketches with AI assistance to produce
              stunning digital illustrations. With ArtblastAI's Smart Sketch
              feature, users can easily bring their artistic visions to life.
              <div
                className="demo-link"
                onClick={() => this.handleOpenTutorial("sketchTutorial")}
              >
                See demo
              </div>
            </li>
            <li>
              <h4>
                What is Image Scaling{" "}
                <MdPhotoSizeSelectLarge
                  className="tutorial-react-icons"
                  size={20}
                />
              </h4>
              Image scaling is a valuable feature offered by ArtblastAI that
              enables users to increase the resolution of their images without
              sacrificing quality or experiencing pixelation. With this
              capability, users can upscale their images to a maximum resolution
              of 2048 x 2048 pixels, ensuring that their artwork maintains its
              clarity and sharpness even when enlarged. Whether you need higher
              resolution images for printing, display purposes, or simply to
              enhance the level of detail, ArtblastAI's image scaling feature
              provides a seamless solution to preserve image quality while
              increasing size.
            </li>
            <li>
              <h4>
                What is In-Painting{" "}
                <RiImageEditFill className="tutorial-react-icons" size={20} />
              </h4>
              Inpainting is a powerful image editing tool in ArtblastAI that
              allows users to make specific changes to their images. By marking
              the area they want to modify with green color, users can provide a
              clear indication to the AI. They can also include a prompt to
              describe the desired changes. The AI combines this information
              with the original image and generates a new image, ensuring that
              only the marked area is modified while the rest remains unchanged.
              Inpainting provides an efficient way to make targeted edits to
              images, just like green screens in movies.
            </li>
            <li>
              <h4>
                What is Background Removal{" "}
                <BsLayersHalf className="tutorial-react-icons" size={20} />
              </h4>
              Background Removal in ArtblastAI is a feature that uses AI to
              automatically remove the background from images. It allows users
              to isolate the main subject or object by eliminating the
              surrounding background. This feature is ideal for various
              applications, providing clean and transparent backgrounds for
              product photography, graphic design, and more.
            </li>
            <li>
              <h4>What is a Credit?</h4>
              In ArtblastAI, a credit is a unit used to represent the cost or
              value associated with performing various operations within the
              platform. Each operation, such as generating an image using
              Text-to-Image, Image-to-Image, or Smart Sketch, scaling an image,
              or performing inpainting, requires a specific number of credits.
              Credits serve as a measure of usage or allocation, allowing users
              to access and utilize the different features and functionalities
              available in ArtblastAI. They enable users to create, modify, and
              enhance their artwork effectively within the platform.
            </li>
            <li>
              <h4>What is "Speed & Quality!" and "Magic!"?</h4>
              These name are used to reference the models used to generate
              images. "Speed & Quality!" refers to SDXL V0.8, which generated
              images of 512px."" Magic!"" refers to SDXL V0.9 with a resolution
              of 1024px. Both models produce excelent results, with "Speed and
              Quality!" being "faster" and cheaper interms of credits, while
              "Magic!" produce state or the art quality images but requires more
              processing time and therefore is slower and more expensive in
              terms of credits.
            </li>
            <li>
              <h4>How many credits does it cost to generate an image?</h4>
              In ArtblastAI, the following features have associated costs in
              credits:
              <br />
              <table style={{ color: "white", margin: "20px" }}>
                <thead>
                  <tr>
                    <th>Feature</th>
                    <th>Credit Cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Text-to-Image</td>
                    <td>
                      Quality 1 : 2 credits, Quality 2 : 3 credits, Quality 3 :
                      6 credits,
                    </td>
                  </tr>
                  <tr>
                    <td>Image-to-Image</td>
                    <td>6 credits,</td>
                  </tr>
                  <tr>
                    <td>Smart Sketch</td>
                    <td>{"6 credits (New Model)"}</td>
                  </tr>
                  <tr>
                    <td>Scaling (up to 2048x2048)</td>
                    <td>1 credit</td>
                  </tr>
                  <tr>
                    <td>Inpainting</td>
                    <td>3 credits</td>
                  </tr>
                  <tr>
                    <td>Background Removal</td>
                    <td>3 credits</td>
                  </tr>
                  <tr>
                    <td>Unclip</td>
                    <td>8 credits</td>
                  </tr>
                </tbody>
              </table>
              These credit costs ensure that users have a clear understanding of
              the resources required for utilizing specific features in
              ArtblastAI, allowing them to manage their credits effectively
              while creating and editing their artwork.
            </li>
            <li>
              <h4>What AI models does artblast uses?</h4>
              ArtblastAI utilizes a range of AI models, including stable
              diffusion models, to power its innovative features and
              capabilities.
            </li>
          </ul>
          <button className="tutorial-close-button" onClick={this.handleClose}>
            Close
          </button>
        </div>
      </div>
    );
  }
}
export { ImgTutorial, SketchTutorial, TextTutorial, FAQ };
